import React, { useState } from 'react';
import RemoveDialog from '../Shared/Remove/RemoveDialog';
import { useTenantsApp } from '../../Context/TenantsApp/TenantsAppContext';
import { DELETE_TENANT, SET_TENANT_ID, TOGGLE_DELETE_APP_DIALOG } from './TenantsAppEvents';
import { deleteProject, getProject } from '../../API/Project/project';
import { deleteOnRuntime } from '../Helpers/DisableDeleteRuntime';
import { deleteDirectory } from '../Helpers/DateLakeStorage';
import { deleteTenantProject, updateTenantProject } from '../../API/Tenant/Tenant';
import { useTranslation } from 'react-i18next';

const DeleteTenantApp = () => {

    const { t } = useTranslation([
        "tenant/tenant",
    ], {
        useSuspense: false
    })


    const { state, dispatch } = useTenantsApp();
    const [inProgress, setInProgress] = useState(false);
    const selectedTenant = state.tenants.find(tenant => tenant._id === state.selectedTenantId);
    if (!selectedTenant) return null;
    const project = selectedTenant.project;
    const { tenantProject } = project;

    const handleClose = () => {
        setInProgress(false);
        dispatch({ type: SET_TENANT_ID, payload: null });
        dispatch({ type: TOGGLE_DELETE_APP_DIALOG });
    }

    const handleDeleteTenantApp = async () => {
        setInProgress(true);
        const projectToDelete = await getProject(project.tenantProjectId)
        if (!projectToDelete) {
            dispatch({ type: DELETE_TENANT, payload: state.selectedTenantId });
            handleClose();
            return;
        }
        for (let instance of projectToDelete.instances) {
            let url = projectToDelete.name.replace(/[^a-zA-Z0-9\~\_\-\.]/g, "") + "_" + instance._id.slice(0, 5);
            let result = await deleteOnRuntime("Application", url, projectToDelete.organizationId, instance._id, null);
            if (result.status === undefined) {
                handleClose();
                return;
            }
        }
        let response = await deleteProject(projectToDelete._id);
        await updateTenantProject(selectedTenant._id, selectedTenant.masterProjectId, { status: "deleted" });
        await deleteTenantProject(selectedTenant._id, selectedTenant.masterProjectId);
        if (response.status === "Success") {
            let path = projectToDelete.organizationId + "/" + projectToDelete._id;
            deleteDirectory(path, projectToDelete._id);
        }
        dispatch({ type: DELETE_TENANT, payload: state.selectedTenantId });
        handleClose();
    }

    return (
        <RemoveDialog
            showLoader={inProgress}
            Title={t("delete_tenant_app")}
            toggleDeleteDialog={handleClose}
            message={t("delete_tenant_app_message", { appName: tenantProject.name, tenantName: selectedTenant.tenantName })}
            message2={t("delete_tenant_app_message2")}
            message3={t("delete_tenant_app_message3")}
            onDelete={handleDeleteTenantApp}
            onCancel={handleClose}
            deleteButtonText={t("delete_button")}
            cancelButtonText={t("cancel_button")}
        />
    );
}
export default DeleteTenantApp;